import {
  getBlogArticles
} from "./chunk-SDFEMQUB.mjs";

// src/hooks/blog/listing.ts
import { useQuery } from "@tanstack/react-query";
var useBlogList = (props) => {
  return useQuery({
    queryKey: ["getBlogList", props],
    queryFn: () => getBlogArticles(props)
  });
};

export {
  useBlogList
};
//# sourceMappingURL=chunk-ELRMLU5N.mjs.map